<template>
  <div>
    <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-header>{{ zone.name }}</v-expansion-panel-header>
        <v-expansion-panel-content>
          <div class="details">
            <span>{{ $t('map.tolldomains.overview.zone_code') }}</span>
            <span>{{ $t('map.tolldomains.overview.service_contact') }}</span>
            <span class="values">{{ zone.code }}</span>
            <span class="values">{{ zone.contact }}</span>
          </div>
          <div class="details">
            <span>{{ $t('map.tolldomains.overview.validity_from') }}</span>
            <span>{{ $t('map.tolldomains.overview.validity_to') }}</span>
            <span class="values">{{ formatDate(zone.startTs) }}</span>
            <span class="values">{{ formatDate(zone.endTs) }}</span>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script lang="ts">
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { Zone } from 'ctp-geometry';
import Utils from '@/mixins/Utils';

@Component
export default class ZonePanel extends Mixins(Utils) {
    @Prop()
    zone!: Zone;
}
</script>
<style lang="scss" scoped>
@import './styles/zone-panel.scss';
</style>
